




import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class Titulo_Reactivo extends Vue {}
